import React, { useContext } from 'react';
import styled from 'styled-components';
import { Container, Row, Col } from 'react-bootstrap';
import brandName from '../../../images/quick_links.png';
import { NavLink } from 'react-router-dom';
import ShoppingContext from '../../context/shoping/shoppingContext';

const MenuNav = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  color: #000;
  width: 100%;
  height: 100%;
  transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(100%)')};
  background-color: #50e3c2;
  // border: 1px solid yellow;
  transition: transform 0.8s ease-in-out;
  z-index: 9999;

  .MenuNav_container {
    // margin: 20px;
    // border: 1px solid black;
  }
  img {
    width: 255px;
    height: 139px;
  }
  a{
    color:black;
  }
  a:hover{
    color:#fff;
  }
  }
`;

const MenuCart = ({ open }) => {
  const shoppingContext = useContext(ShoppingContext);

  const { freeShipping } = shoppingContext;
  return (
    <MenuNav open={open}>
      <div className='MenuNav_container'>
        <div className='MenuCart_nav'>
          <div>
            <div className='coloe'>
              <NavLink to='/login'>Login</NavLink>
            </div>
            <div variant='primary'>
              <NavLink to='/cart' className='text-dark'>
                <i className='fa fa-shopping-cart' aria-hidden='true'>
                  <span variant='light'>{freeShipping.length}</span>
                </i>
              </NavLink>
            </div>
          </div>
        </div>
      </div>
      <Container>
        <Row>
          <Col>
            <img src={brandName} alt='' />
          </Col>
        </Row>
        <Row className='MenuCart_labels'>
          <Col md={{ span: 3, offset: 3 }}>Record Label</Col>
          <Col>Live Experiences</Col>
          <Col>Apparel</Col>
        </Row>
        <Row className='MenuCart_links mt-3'>
          <Col>
            <Container>
              <Row>
                <NavLink to='/'></NavLink>Our story
              </Row>
              <NavLink to='/contactUs'>
                <Row>Contact us</Row>
              </NavLink>
            </Container>
          </Col>
          <Col>
            <Container className='my-2'>
              <NavLink to='/recordLabel'>
                <Row>Releases</Row>
              </NavLink>
              <NavLink to='/artist'>
                <Row>Artists</Row>
              </NavLink>
              <NavLink to='/submission'>
                <Row>Submissions</Row>
              </NavLink>
            </Container>
          </Col>
          <Col>
            <Container className='my-2'>
              <NavLink to='/liveExperience'>
                <Row>Upcoming events</Row>
              </NavLink>
              <NavLink to='/buyTickets'>
                <Row>Buy tickets</Row>
              </NavLink>
              <NavLink to='/pastEvents'>
                <Row>Past events</Row>
              </NavLink>
            </Container>
          </Col>
          <Col>
            <Container className='my-2'>
              <NavLink to='/apparel'>
                <Row>Collections</Row>
              </NavLink>
              <NavLink to='/tees'>
                <Row>Tees</Row>
              </NavLink>
              <NavLink to='/hoodies'>
                <Row>Hoodies</Row>
              </NavLink>
              <NavLink to='/masks'>
                <Row>Masks</Row>
              </NavLink>
              <NavLink to='/apparel'>
                <Row>Shipping & returns </Row>
              </NavLink>
            </Container>
          </Col>
        </Row>
      </Container>
    </MenuNav>
  );
};
export default MenuCart;
